import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class ChangeIntegrationStatusCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IChangeIntegrationStatusParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'api/{applicationId}/{status}';
  public override setParameters(parameters: IChangeIntegrationStatusParameters) {
    this._commandUrl = this._commandUrl
      .replace('{applicationId}', parameters.applicationId.toString())
      .replace('{status}', parameters.status.toString());
  }
}

export interface IChangeIntegrationStatusParameters extends ICommandParameters {
  applicationId: number;
  status: boolean;
}
